import React, { forwardRef, Ref, useMemo } from 'react'
import { IconType } from 'core/components/icons/types'
import Icon from 'core/components/icons/Icon'
import Button, { ButtonProps } from 'core/components/buttons/Button'

interface AsyncButtonProps extends Omit<ButtonProps, 'prefix'> {
  status?: 'loading' | 'success' | 'error' | 'idle'
  icon?: `${IconType}`
}
/**
 * @deprecated Use Button instead
 */
const AsyncButton = forwardRef(
  (
    { icon, status = 'idle', ...props }: AsyncButtonProps,
    ref: Ref<HTMLButtonElement>
  ) => {
    const prefix = useMemo(() => {
      if (status === 'idle' && icon) {
        return <Icon name={icon} className="mb-[2px]" size={14} noWrapper />
      }
      if (status === 'loading') {
        return <Icon name="loading" size={14} className="mb-[3px]" noWrapper />
      }
      if (status === 'success') {
        return (
          <Icon
            name="check-circle-outline"
            size={14}
            className="mb-[2px]"
            noWrapper
          />
        )
      }
      if (status === 'error') {
        return (
          <Icon
            name="close-circle-outline"
            size={14}
            className="mb-[2px]"
            noWrapper
          />
        )
      }
    }, [status, icon])

    return <Button ref={ref} prefix={prefix} {...props} />
  }
)
export default AsyncButton
